import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { hasConsented, acceptAll } from "@/lib/cookies";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!hasConsented()) {
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleOk = () => {
    acceptAll();
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up"
      role="dialog"
      aria-label="Cookie notice"
      aria-live="polite"
    >
      <div className="container mx-auto">
        <div className="bg-card border border-border rounded-xl shadow-elevated p-6 max-w-4xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground flex-1 pr-4">
              This website uses essential cookies to ensure it functions properly.
            </p>
            <div className="flex-shrink-0">
              <Button size="sm" onClick={handleOk} className="min-h-[44px] min-w-[44px] px-6">
                OK
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
